import React, { useState } from 'react';
import {
  ETAPA_COPILOTO_LABELS,
  ETAPAS_COPILOTO,
  FORMA_PAGO_COPILOTO_LABELS,
  FORMAS_PAGO_COPILOTO,
  labelFromCatalog,
  PRIORIDAD_LABELS,
  PRIORIDADES_COPILOTO,
  PROXIMA_ACCION_LABELS,
  PROXIMAS_ACCIONES_COPILOTO,
  TEMPERATURA_COPILOTO_LABELS,
  TEMPERATURAS_COPILOTO,
} from '../../../services/copilotoComercialService';

export default function ResultadoCopiloto({ analisis, onChange }) {
  const [tagInput, setTagInput] = useState('');

  if (!analisis) {
    return null;
  }

  const update = (patch) => onChange({ ...analisis, ...patch });
  const updateAccion = (patch) => update({ proximaAccion: { ...analisis.proximaAccion, ...patch } });

  const eliminarEtiqueta = (tag) => {
    update({ etiquetasSugeridas: analisis.etiquetasSugeridas.filter((item) => item !== tag) });
  };

  const agregarEtiqueta = () => {
    const tag = tagInput.trim();
    if (!tag || analisis.etiquetasSugeridas.includes(tag)) return;
    update({ etiquetasSugeridas: [...analisis.etiquetasSugeridas, tag] });
    setTagInput('');
  };

  return (
    <section className="crm-prospectos-card copiloto-card">
      <div className="crm-prospectos-section-head">
        <h2>Resultado del Copiloto</h2>
      </div>

      <div className="copiloto-result-grid">
        <article>
          <h3>Diagnostico comercial</h3>
          <div className="crm-prospectos-info-grid">
            <div className="crm-prospectos-info-item"><span>Proyecto detectado</span><strong>{analisis.proyectoDetectado || '-'}</strong></div>
            <div className="crm-prospectos-info-item"><span>Confianza</span><strong>{Math.round(Number(analisis.confianzaProyecto || 0) * 100)}%</strong></div>
            <label><span>Etapa comercial</span><select value={analisis.etapaComercial} onChange={(event) => update({ etapaComercial: event.target.value })}>{ETAPAS_COPILOTO.map((item) => <option key={item} value={item}>{labelFromCatalog(ETAPA_COPILOTO_LABELS, item)}</option>)}</select></label>
            <label><span>Temperatura</span><select value={analisis.temperatura} onChange={(event) => update({ temperatura: event.target.value })}>{TEMPERATURAS_COPILOTO.map((item) => <option key={item} value={item}>{labelFromCatalog(TEMPERATURA_COPILOTO_LABELS, item)}</option>)}</select></label>
            <label><span>Forma de pago</span><select value={analisis.formaPago} onChange={(event) => update({ formaPago: event.target.value })}>{FORMAS_PAGO_COPILOTO.map((item) => <option key={item} value={item}>{labelFromCatalog(FORMA_PAGO_COPILOTO_LABELS, item)}</option>)}</select></label>
            <label className="is-wide"><span>Intencion principal</span><input value={analisis.intencionPrincipal} onChange={(event) => update({ intencionPrincipal: event.target.value })} /></label>
          </div>
        </article>

        <article>
          <h3>Resumen</h3>
          <textarea value={analisis.resumen} onChange={(event) => update({ resumen: event.target.value })} rows="5" />
        </article>

        <article>
          <h3>Objeciones detectadas</h3>
          {analisis.objecionesDetectadas.length === 0 ? <p className="crm-prospectos-empty">Sin objeciones detectadas.</p> : null}
          <div className="copiloto-chip-list">
            {analisis.objecionesDetectadas.map((objecion) => <span key={objecion}>{objecion}</span>)}
          </div>
        </article>

        <article>
          <h3>Siguiente accion recomendada</h3>
          <div className="crm-prospectos-form-grid">
            <label><span>Tipo</span><select value={analisis.proximaAccion.tipo} onChange={(event) => updateAccion({ tipo: event.target.value })}>{PROXIMAS_ACCIONES_COPILOTO.map((item) => <option key={item} value={item}>{labelFromCatalog(PROXIMA_ACCION_LABELS, item)}</option>)}</select></label>
            <label><span>Fecha sugerida</span><input type="datetime-local" value={analisis.proximaAccion.fechaSugerida ? String(analisis.proximaAccion.fechaSugerida).slice(0, 16) : ''} onChange={(event) => updateAccion({ fechaSugerida: event.target.value })} /></label>
            <label><span>Prioridad</span><select value={analisis.proximaAccion.prioridad} onChange={(event) => updateAccion({ prioridad: event.target.value })}>{PRIORIDADES_COPILOTO.map((item) => <option key={item} value={item}>{labelFromCatalog(PRIORIDAD_LABELS, item)}</option>)}</select></label>
            <label className="is-full"><span>Motivo</span><textarea value={analisis.proximaAccion.motivo} onChange={(event) => updateAccion({ motivo: event.target.value })} rows="3" /></label>
          </div>
        </article>

        <article>
          <h3>Alertas</h3>
          {analisis.alertas.length === 0 ? <p className="crm-prospectos-empty">Sin alertas.</p> : null}
          <div className="copiloto-alert-list">
            {analisis.alertas.map((alerta) => <p key={alerta}>{alerta}</p>)}
          </div>
        </article>

        <article>
          <h3>Etiquetas sugeridas</h3>
          <div className="copiloto-chip-list">
            {analisis.etiquetasSugeridas.map((tag) => (
              <button key={tag} type="button" onClick={() => eliminarEtiqueta(tag)} title="Eliminar etiqueta">{tag} x</button>
            ))}
          </div>
          <div className="copiloto-tag-add">
            <input value={tagInput} onChange={(event) => setTagInput(event.target.value)} placeholder="Agregar etiqueta" />
            <button type="button" onClick={agregarEtiqueta}>Agregar</button>
          </div>
        </article>
      </div>
    </section>
  );
}
